import { render } from "./ContentCategoryPage.vue?vue&type=template&id=1f9207d9&ts=true"
import script from "./ContentCategoryPage.vue?vue&type=script&lang=ts"
export * from "./ContentCategoryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Contents/Categories/ContentCategoryPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f9207d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f9207d9', __exports__)) {
    api.reload('1f9207d9', __exports__)
  }
  
  module.hot.accept("./ContentCategoryPage.vue?vue&type=template&id=1f9207d9&ts=true", () => {
    api.rerender('1f9207d9', render)
  })

}


export default __exports__